import Yup from '../../../helpers/custom-yup'

export const addressFieldsSchema = Yup.object().shape({
	zipCode: Yup.string()
		.postalCode()
		.required('Informe o CEP'),
	street: Yup.string()
		.required('Informe o logradouro')
		.nullable(),
	number: Yup.string()
		.required('Informe o número')
		.nullable(),
	complement: Yup.string().nullable(),
	neighborhood: Yup.string()
		.required('Informe o bairro')
		.nullable(),
	city: Yup.string().required('Informe a cidade'),
	state: Yup.string().required('Informe o estado')
})
